<ng-container *ngFor="let pharmacy of exists; trackBy: trackById">
    <div class="pharmacy-container">
      <div class="top-info-wrapper">
        <div class="left">
          <p class="title">{{ pharmacy.title }}</p>
          <div class="address-with-schedule">
            <p class="address">{{ pharmacy.address }}</p>
            <div class="schedule">
              <img class="clock" alt="schedule-icon" title="schedule" src="../../../../assets/icons/clock.svg">
              <span class="text">{{ pharmacy.schedule }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="wrapper">
            <p class="count">{{ 'positions-available' | transloco }}: {{ pharmacy.qty }}</p>
            <div class="prices-wrapper">
              <p class="prices">{{ pharmacy.minPrice }} - {{ pharmacy.maxPrice }}грн</p>
              <img
                [class.expanded-pharmacy]="pharmacy.isExpanded" class="toggler"
                (click)="togglePharmacy(pharmacy)" alt="arrow"
                title="arrow" src="../../../../assets/icons/pharmacy-arrow.svg">
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-products" [ngStyle]="{'display': pharmacy.isExpanded ? 'flex' : 'none'}">
        <div class="product-wrapper" *ngFor="let product of pharmacy.goods; trackBy: trackById">
          <div class="product-info">
            <a [routerLink]="product | infoDrugRouterLink">
              <picture>
                <source [srcset]="(imgPath + '160-120/' + product.goodImg + '.webp') | isImgNull" type="image/webp">
                <img bz-image class="image"
                     [src]="(imgPath + '160-120/' + 'png/' + product.goodImg + '.png') | isImgNull"
                     [alt]="product.goodTitle"
                     [title]="product.goodTitle">
              </picture>
            </a>
            <div class="title-with-producer">
              <p class="product-title">{{ product.goodTitle }}</p>
              <p class="product-producer">{{ product.producer }}</p>
            </div>
          </div>
          <div class="product-prices">
            <span class="price">{{ product.price }}грн</span>
            <span class="price-reserve">{{ product.priceReserve }}грн</span>
            <span class="discount">{{ product.discount }}грн</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
